import { withDependencies } from '@wix/thunderbolt-ioc'
import { ISiteMembersApi, SiteMembersApiSymbol } from 'feature-site-members'
import { LoginButtonFeatureProps } from '@wix/thunderbolt-components'
import { ComponentWillMount, ViewerComponent } from 'feature-components'

const componentType = 'LoginButton'

const loginButtonPageFactory = (
	siteMembersApi: ISiteMembersApi
): ComponentWillMount<ViewerComponent<LoginButtonFeatureProps>> => {
	const getNewProps = async () => {
		const props: LoginButtonFeatureProps = {
			isLoggedIn: false,
			userName: '',
			onLogin: () => {
				siteMembersApi.promptLogin()
			},
			onLogout: () => {
				siteMembersApi.logout()
			},
		}
		try {
			const memberDetails = await siteMembersApi.getMemberDetails()

			if (memberDetails) {
				props.isLoggedIn = true
				props.userName = memberDetails.nickname || memberDetails.memberName || memberDetails.loginEmail
			}
			return props
		} catch {
			return props
		}
	}

	return {
		componentTypes: [componentType],
		async componentWillMount({ updateProps }) {
			const updatePropsCallback = async () => updateProps(await getNewProps())

			const onLoginCallbackId = siteMembersApi.registerToUserLogin(updatePropsCallback)
			const onMemberDetailsRefreshCallbackId = siteMembersApi.registerToMemberDetailsRefresh(updatePropsCallback)
			await updatePropsCallback()

			return async () => {
				siteMembersApi.unRegisterToUserLogin(onLoginCallbackId)
				siteMembersApi.unRegisterToMemberDetailsRefresh(onMemberDetailsRefreshCallbackId)
			}
		},
	}
}

export const LoginButtonPage = withDependencies([SiteMembersApiSymbol], loginButtonPageFactory)
